<template>
  <div class="nuttrema-index-virtual-group-list">

    <nuttrema-loader v-if="state.fetching"></nuttrema-loader>

    <template v-else>
      <div class="nuttrema-index-virtual-group-list__header">
        <nuttrema-group-and-sort-virtual
          :grouping="grouping" :sorting="sorting" :orders="orders"
          @changeGroupBy="onChangeGroupBy"
          @changeSortBy="onChangeSortBy"
          @changeOrder="onChangeOrder">
        </nuttrema-group-and-sort-virtual>
      </div>

      <div class="nuttrema-index-virtual-group-list__content">
        <nuttrema-empty-result
           v-if="isEmptyState"
           slot="central"
           class="with-logo"
           predefined-set="landscape">
        </nuttrema-empty-result>

        <ul
          v-else
          class="nuttrema-index-virtual-group-list__content__list">
          <nuttrema-index-list-item
             v-for="(group, key) in list"
            :group="group"
            :title="getTitle(key)"
            :key="key"
            :meta="meta"
            :edit="edit">
          </nuttrema-index-list-item>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import { isArray, isEmpty } from 'lodash';
import VirtualGrouping from 'components/mixins/virtual-grouping';

import PageProps from 'components/mixins/page-props';

import NuttremaIndexListItem from './nuttrema-index-list-item';
import NuttremaGroupAndSortVirtual from './nuttrema-group-and-sort-virtual';

export default {
  name: 'nuttrema-index-virtual-group-list',
  mixins: [
    PageProps,
    VirtualGrouping,
  ],
  props: {
    state: {
      required: true,
      default: null,
    },
    showHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    NuttremaIndexListItem,
    NuttremaGroupAndSortVirtual,
  },
  methods: {
    getTitle(key) {
      return key === 'undefined' ? this.$t('label.undefined') : (key.startsWith('label') ? this.$t(`${key}`) : key);
    },
  },
  computed: {
    isEmptyState() {
      if (isArray(this.state)) return isEmpty(this.state);
      return isEmpty(this.state.data);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  .nuttrema-index-virtual-group-list {
    display: flex;
    flex-grow: 1;
    align-self: stretch;
    flex-direction: column;
    position: relative;

    @at-root #{&}__header {
      display: flex;
      height: 4em;
      display: flex;
      min-height: 4em;
      padding: 0.5em 1em;
      color: $gray-light;
      align-self: stretch;
      align-items: center;
      border-bottom: 2px solid #DBE2EF;
      background-color: rgba(#DBE2EF, 0.25);
    }

    @at-root #{&}__content {
      height: 1px;
      flex-grow: 1;
      display: flex;
      align-self: stretch;
      flex-direction: column;
      background-color: #fff;
      // background-color: lighten($index-list-bg, 2.5%);

      @at-root #{&}__list {
        flex-grow: 1;
        display: flex;
        overflow: hidden;
        overflow-y: auto;
        align-self: stretch;
        flex-direction: column;
        background-color: lighten($index-list-bg, 2.5%);

        @supports (-moz-appearance:none) {
          height: 0px;
        }
      }

      @at-root #{&}__note {
        flex-grow: 1;
        display: flex;
        flex-shrink: 0;
        font-size: 0.9em;
        text-align: right;
        align-self: stretch;
        padding-bottom: 2em;
        align-items: flex-end;
        margin: 0.75em 1em 2em;
        flex-direction: column;

        .note__title {
          font-weight: 500;
          display: flex;
        }

        ul {
          display: flex;
        }
      }
    }

    // .nuttrema-theme-professional-topography & {
    //   .nuttrema-index-virtual-group-list__content {
    //     background: #fff;
    //   }
    // }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/list/nuttrema-index-virtual-group-list.vue